export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            手机观影
          </h2>
          <p className="mt-2 text-sm text-foreground-500">随时随地，高清追剧不停歇</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="bg-gradient-to-br from-background-100 to-background-50 rounded-2xl p-8 md:p-12 border border-background-200/60 flex flex-col md:flex-row items-center gap-8">
            {/* Left — Phone Mockup */}
            <div className="shrink-0">
              <div className="w-44 md:w-52 rounded-3xl border-4 border-foreground-900 overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20showing%20movie%20streaming%20app%20interface%20with%20film%20posters%20grid%2C%20warm%20cinematic%20color%20scheme%2C%20clean%20modern%20UI%2C%20dark%20background%2C%20movie%20thumbnails%20with%20ratings&width=400&height=700&seq=app-phone-lulu-03&orientation=portrait"
                  alt="鲁鲁影院手机端观影界面"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            {/* Right — Info */}
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                移动端观影体验
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                鲁鲁影院完美适配手机与平板设备，无需下载任何 App，打开浏览器即可享受高清流畅的观影体验。支持横竖屏自动切换，智能记忆播放进度，让你在地铁、午休或旅途中也能轻松追剧。
              </p>
              <div className="flex flex-wrap gap-2 justify-center md:justify-start">
                <span className="px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">HTML5 播放器</span>
                <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">极速加载</span>
                <span className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">省流量模式</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}